/**
 * 常量
 * @author  baoleilei(baoleilei@baidu.com)
 * @file    index.js
 * @version 1.0
 */


/**
 * 判断是不是线上环境
 *
 * @return {bollean} 是不是线上环境
 */

function isOnlineEnv() {
    return process.env.NODE_ENV === 'production';
}

export let passportOrigin = isOnlineEnv() ? window.location.protocol + '//passport.baidu.com'
    : window.location.protocol + '//passport.baidu.com';

// uc线上登录
export let ucPassportOrigin = isOnlineEnv() ? window.location.protocol + '//cas.baidu.com'
    : window.location.protocol + '//cas.baidu.com';

// uc根据环境动态判断
// export let ucPassportOrigin = isOnlineEnv() ? window.location.protocol + '//cas.baidu.com'
//     : window.location.protocol + '//cas-off.baidu.com';
